<template> 

  <v-container style="max-width:1800px">

        <v-dialog v-model="dialog" width="1200px">
          <v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialog = false">
                Fechar
              </v-btn>
            </v-card-actions>
            <v-card-title>
              <span class="headline">Selecionar ítem</span>
            </v-card-title>
            <v-card-text>
              <v-simple-table      >
                <template v-slot:default>
                  <thead>
                <tr>
                      <th style="width: 300px" class="text-left">Código</th>
                      <th class="text-left">Descrição</th>

                      <th class="text-right">Adicionar</th>
                    </tr>
                  </thead>
                  <tbody>
                  

                    <tr
                      v-for="(service, indexService) in services"
                      :key="service.id"
                    >
                      <td>{{ service.code }}</td>
                      <td>{{ service.description }}</td>
          
                      <td class="text-right">
                        <v-btn
                          class="primary"
                        @click="addService(indexService)"
                          >+</v-btn>
                      </td>
                    </tr>
               

                  </tbody>
                </template>
              </v-simple-table>

             
            </v-card-text>
          </v-card>
        </v-dialog>

  <v-card>  
        <v-toolbar color="primary" dark>
         Serviços padrão 
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-container style="max-width: 90%">

          <div v-if = "defaultSettings">

            <v-row     v-for="(item,index) in defaultSettings.services"
          v-bind:key="item.id" > 
            <v-col cols="12" md="1">
                <v-btn class="secondary" @click="deleteService(index)" >  <v-icon>mdi-delete</v-icon></v-btn>
            </v-col>
            
            <v-col cols="12" md="3">
                  <v-text-field
                label="Código"
                hide-details="auto"
                v-model="item.device.code"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="8">
                  <v-text-field
                label="Descrição"
                hide-details="auto"
                v-model="item.device.description"
              ></v-text-field>
            </v-col>

            </v-row>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="dialog = true;"> <v-icon>mdi-plus</v-icon></v-btn>
            </v-row>

          </div>
        </v-container>


      </v-card>
  </v-container>
</template>

<script>
export default {
  name: "default-settings-card",
  props: ["defaultSettings","services"],
  data(){
    return{
        dialog:false,
    }
  },

  methods: {
       addService(index){
       var d = new Date()
       var s = Object.assign({}, this.services[index])
       var service = {device:s, deviceId:s.id, id:d.getTime() }
       this.defaultSettings.services.push(service)
       this.dialog= false;
   },


    deleteService(index){
       console.log("delete:" + index);
         this.defaultSettings.services.splice(index,1)
   },
  }
  
};
</script>

<style scoped>
</style>